import React from 'react';
import PropTypes from 'prop-types';
import { theme } from '@ui/theme';

export const PlumXCloseIcon = ({
  color = 'background.dark',
  size = '32',
  alt = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {alt && <title>{alt}</title>}
      <rect width="32" height="32" rx="16" fill={theme.colors.get(color)} />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9941 17.5745L11.9621 21.6065C10.9282 22.6403 9.3627 21.06 10.3965 20.0262L14.4285 15.9942L10.3965 11.9622C9.3627 10.9283 10.9282 9.36278 11.9621 10.3966L15.9941 14.4286L20.0261 10.3966C21.0599 9.36278 22.6402 10.9283 21.6064 11.9622L17.5744 15.9942L21.6064 20.0262C22.6402 21.06 21.0599 22.6403 20.0261 21.6065L15.9941 17.5745Z"
        fill={theme.colors.hero.plum}
      />
    </svg>
  );
};

PlumXCloseIcon.displayName = 'PlumXCloseIcon';
PlumXCloseIcon.propTypes = {
  alt: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
